import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { DataTable } from "./components/data-table";
import { useGetEmailReportQuery } from "@/services/conciliation/email-report";
import { getColumns } from "./components/columns";
import { useFilterState } from "./filter/hooks/filterState";
import { handeOrderBy } from "@/utils/pagination";
import { ConciliationEmailReportType } from "./components/conciliation-email-report-types";
import PageError from "components/page-error";
import { Load } from "components/load";

const EmailReport = () => {
    const filterState = useFilterState();
    const { filters } = filterState || { filters: {} };
    const orderBy = handeOrderBy(filters.order);
    const { data: emails, isLoading, error } = useGetEmailReportQuery({
        search: filters.search,
        reportType: filters.reportType ? filters.reportType : ConciliationEmailReportType.EMAILS_BY_STORE,
        ...(filters.storeCode ? { storeCode: filters.storeCode } : {}),
        ...(filters.regional ? { regional: filters.regional } : {}),
        ...(filters.operator ? { operator: filters.operator } : {}),
        ...(filters.date ? { date: filters.date } : {}),
        ...(filters.sent_at ? { sent_at: filters.sent_at } : {}),
        ...(filters.storeAllowedToReceiveEmails ? { storeAllowedToReceiveEmails: filters.storeAllowedToReceiveEmails } : {}),
        ...(filters.type ? { type: filters.type } : {}),
        ...(filters.is_finalized ? { is_finalized: filters.is_finalized } : {}),
        ...(filters.from_date ? { from_date: filters.from_date } : {}),
        ...(filters.to_date ? { to_date: filters.to_date } : {}),
        ...(filters.status ? { status: filters.status } : {}),
        ...(filters.aggregatedStatus ? { aggregatedStatus: filters.aggregatedStatus } : {}),
        ...(filters.responsible ? { responsible: filters.responsible } : {}),
        ...(filters.dateType ? { dateType: filters.dateType } : {}),
        orderBy: JSON.stringify(orderBy),
        page: filters?.meta?.page || 1,
        perPage: filters?.meta?.perPage || 10,
        meta: {
            page: filters?.meta?.page || 1,
            perPage: filters?.meta?.perPage || 10,
        },
    });

    const { data, meta } = emails || { data: [], meta: {} };

    if (isLoading) return <Load />;
    if (error) {
        return <PageError status={500} message={"ERRO INTERNO NO SERVIDOR"} />;
    }

    return (
        <PageLayout>
            <PageTitle
                title="Relatório de envio de e-mails"
                description="Acompanhe o relatório de envio de e-mails do sistema"
            />
            <ContentContainer>
                <DataTable data={data} meta={meta} columns={getColumns(data)} />
            </ContentContainer>
        </PageLayout>
        
    );
};

export default EmailReport;
